import { Injectable } from '@angular/core';

import { SystemService } from '../../core/system/system.service';

@Injectable({
    providedIn: 'root'
})
export class IamCoreService {
    constructor(protected systemService: SystemService) { }

    public hasRoleOrMaster(roleName?: string): boolean {
        for (const role of this.systemService.getUser().roles) {
            if (role.name === roleName || (role.name === 'master' && role.godMode)) {
                return true;
            }
        }

        return false;
    }
}
